// extracted by css-extract-rspack-plugin
export default {"section":"section-JIcPfL","header":"header-FXHBEN","actions":"actions-YBvs_5","emptyState":"emptyState-v2r9OW","tableContainer":"tableContainer-kp1wsg","loader":"loader-y5LlQZ"};